import styled from 'styled-components';
import { OPERATIONS_TABLE_COLUMNS } from '../../Transactions.constants';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.div`
  width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  border-radius: 14px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.palette.primary.background};
`;

export const Header = styled.div`
  display: grid;
  grid-template-columns: ${OPERATIONS_TABLE_COLUMNS};
  gap: 16px;
  align-items: center;
  height: 47px;
  padding: 0 20px;
  background-color: ${({ theme }) => theme.palette.system.lightBackground};
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
`;

export const HeaderCell = styled(Typography.Title).attrs({ $variant: '2' })`
  color: ${({ theme }) => theme.palette.primary.labels};
`;
